import React, { useEffect } from "react";
import {
  Box,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from "@mui/material";
import { Delete, DragIndicator } from "@mui/icons-material";
import { useManagementTextField } from "hooks/forms/ManagementHooks";
import CustomTextField from "../../shared/textFields/CustomTextField";

export default function TemplateChecklistItemEditor({
  item,
  index,
  onContentChange,
  onRemove,
  isSaving,
  provided,
  snapshot
}) {
  // Hook para o conteúdo do item seguindo padrão do projeto
  const { reset: resetContent, ...contentField } = useManagementTextField(item.content || "");

  // Sincronizar o valor do hook com o item quando ele muda
  useEffect(() => {
    if (contentField.value !== item.content) {
      contentField.onCustomChange(item.content || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.content]);

  // Quando o conteúdo muda, notifica o componente pai
  const handleContentChange = (event) => {
    const newContent = event.target.value;
    contentField.onChange(event);
    onContentChange(index, newContent);
  };

  // Sobrescrever o onChange do hook com nossa lógica
  const contentParams = {
    ...contentField,
    onChange: handleContentChange
  };

  return (
    <Box
      ref={provided.innerRef}
      {...provided.draggableProps}
      sx={{
        mb: 1,
        bgcolor: snapshot.isDragging ? "action.selected" : "background.paper",
        borderRadius: 1,
        border: "1px solid",
        borderColor: snapshot.isDragging ? "primary.main" : "divider",
        transition: "all 0.2s ease",
      }}
    >
      <ListItem sx={{ py: 1 }}>
        <Box
          {...provided.dragHandleProps}
          sx={{
            display: "flex",
            alignItems: "center",
            mr: 2,
            cursor: "grab",
            "&:active": { cursor: "grabbing" },
          }}
        >
          <DragIndicator color="action" />
        </Box>

        <ListItemText
          primary={
            <CustomTextField
              params={contentParams}
              placeholder="Conteúdo do item..."
              variant="standard"
              fullWidth
              disabled={isSaving}
              sx={{
                "& .MuiInput-underline:before": { borderBottom: "none" },
              }}
            />
          }
          secondary={`Item ${index + 1}`}
        />

        <ListItemSecondaryAction>
          <IconButton
            edge="end"
            onClick={() => onRemove(index)}
            disabled={isSaving}
            size="small"
            sx={{ color: "error.main" }}
          >
            <Delete />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </Box>
  );
}